<template>
  <v-container fluid>
    <div class="modal-padding cp3-modal fix-error-message">
      <v-row>
        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">Edit Teacher:</div>
            <div class="field-data">
              <v-text-field v-model="name" class="fix-200"></v-text-field>
              <InputError :data="error.name" />
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">Edit Email:</div>
            <div class="field-data">
              <v-text-field v-model="email" class="fix-200"></v-text-field>
              <InputError :data="error.email" />
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">
              Category:
            </div>

            <div class="field-data">
              <v-select
                v-model="selectedClass"
                @change="getSubjects({ change: false })"
                :items="classes"
                hide-details
                dense
                class="fix-200"
                filled
              ></v-select>
              <InputError :data="error.dataType" />
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="12">
          <div class="show-drop-down">
            <div class="label-data">
              Subjects:
            </div>

            <div class="field-data">
              <multi-select
                allText="All subject"
                :items="subjects"
                ref="subjectSelect"
                :onChange="onSubjectSelect"
                label="Select Subjects"
                hide-details
                dense
                outlined
                class="fix-200"
              ></multi-select>
              <InputError :data="error.subjects" />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <div class="select-center-blk popup-select-center">
            <div class="teacher-border">
              <div
                v-if="selectedCenterList.length"
                class="selectedCenterListouter"
                id="centerContainer"
              >
                <div
                  v-for="(center, idx) in selectedCenterList"
                  class="selectedCenterList"
                  :key="idx"
                  :id="center.class"
                >
                  <div class="center-name-v">
                    {{ center.text }}
                  </div>

                  <div class="radio-center">
                    <div
                      class="check-cust center-check"
                      v-for="(batch, ind) in center.batches"
                      :title="batch.text"
                      :key="ind"
                    >
                      <v-checkbox
                        v-model="batch.checked"
                        :label="batch.text"
                        dense
						:readonly="getBatchReadOnly(batch)"
                        :disabled="getBatchReadOnly(batch) ||batch.disabled"
						hide-details
                      ></v-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="select-center cp3-select-center">
                  <v-select
                    :items="centers"
                    v-model="selectedCenterId"
                    hide-details
                    no-data-text="No centers available"
                    dense
                    class="fix-200"
                    filled
                    solo
                    attach
                    auto
                    placeholder="Choose center"
                  ></v-select>
                </div>
              </div>
            </div>
            <InputError :data="error.batches" />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12">
          <div class="bottom-btn left-btn">
            <v-btn
              :loading="saveLoading"
              @click="updateTeacher(false)"
              class="right-btn cust-btn"
              color="primary"
              >Done</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "EditStudentBatchDetails",
  props: ["onClose", "data", "status", "isApprove"],
  data() {
    return {
      name: this.data ? this.data.name : "",
      email: this.data ? this.data.email : "",
      approvalLoading: false,
      saveLoading: false,
      centers: [],
      allCenters: [],
      showAddcenterButton: true,
      selectedCenterId: null,
      selectedClass: this.data.selectedClass ? this.data.selectedClass : {},
      selectedSubject: this.data.subjects ? this.data.subjects : [],
      classes: [],
      subjects: [],
      selectedCenterList: [],
      error: {
        name: {
          type: null,
          message: "Please enter name",
        },
        email: {
          type: null,
          message: "Please enter email",
        },
        dataType: {
          type: null,
          message: "Please Select Category",
        },
        subjects: {
          type: null,
          message: "Please Select Subject",
        },
        batches: {
          type: null,
          message: "Please Select Batch",
        },
      },
    };
  },
  methods: {
    ...mapActions({
      getCenters: "centerAndBatchStore/getCenters",
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      updateExternalUser: "userStore/updateExternalUser",
      getTeacherDetails: "userStore/getTeacherDetails",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      getBatches: "centerAndBatchStore/getBatches",
    }),
    validate() {
      this.email = this.removeWhiteSpacesFromEmail(this.email);
      let isValid = true;
      this.error.name.type = null;
      this.error.email.type = null;
      this.error.dataType.type = null;
      this.error.subjects.type = null;
      this.error.batches.type = null;
      let batches = [];
      this.selectedCenterList.map((sc) => {
        return sc.batches.map((b) => {
          if (b.checked) {
            batches.push(b.value);
          }
        });
      });
      if (!this.name || this.name.trim().length < 1) {
        this.error.name.type = "error";
        this.error.name.message = "Please enter name";
        isValid = false;
      }
      if (!this.email || this.email.length < 1) {
        this.error.email.type = "error";
        this.error.email.message = "Please enter email ID.";
        isValid = false;
      } else if (!this.isValidEmail(this.email)) {
        this.error.email.type = "error";
        this.error.email.message =
          "Please enter a valid email ID. ";
        isValid = false;
      }
      if (!this.selectedClass) {
        this.error.dataType.type = "error";
        isValid = false;
      }
      if (!this.selectedSubject || this.selectedSubject.length <= 0) {
        this.error.subjects.type = "error";
        isValid = false;
      }
      // if (!batches || batches.length <= 0) {
      //   this.error.batches.type = "error";
      //   isValid = false;
      // }

      return isValid;
    },
    getCentersFunction() {
      if (this.isCoordinator()) {
        return "getCentersByUser";
      }
      return "getCenters";
    },
    isCoordinator() {
      const user = JSON.parse(sessionStorage.getItem("user"));

      if (user && user.role_id === constants.ROLES_ID.CO) {
        return true;
      }
      return false;
    },
    getBatchReadOnly(batch) {
      return (
        this.allCenters.filter((x) => Number(x.value) === Number(batch.center_id))
          .length === 0
      );
    },
    getSubjects(item) {
      let reqData = {
        level: 2,
        parent: this.selectedClass.id,
      };
      this.subjects = [];
      if (!item.change) {
        this.selectedSubject = null;
      }
      this.$root.showLoader = true;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.subjects = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x.id;
            if (this.selectedSubject && this.selectedSubject.length > 0) {
              c.checked = this.selectedSubject.includes(x.id);
            }
            return c;
          });
          this.isLoadingFirstTime = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requestGetClasses() {
      let reqData = {
        level: 1,
      };

      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.loading = false;
          this.classes = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x;
            if (this.data.class_code === x.title) {
              this.selectedClass = x;
            }
            return c;
          });
          if (this.selectedClass.id) {
            this.getSubjects({ change: true });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    requestGetCenters(alreadySelectedCenter) {
      this.centers = [];
      this.$root.showLoader = true;
      this[this.getCentersFunction()]()
        .then((response) => {
          this.$root.showLoader = false;
          this.allCenters = response.map((x) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
          this.centers = this.allCenters.filter((c) => {
            return alreadySelectedCenter.indexOf(c.value) === -1;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onCenterchange(centerIds) {
      this.selectedCenterId = centerIds;
    },
    updateTeacher() {
      this.loading = true;
      if (this.validate()) {
        let batches = [];
        this.selectedCenterList.map((sc) => {
          return sc.batches.map((b) => {
            if (b.checked) {
              batches.push(b.value);
            }
          });
        });
        this.saveLoading = true;
        this.updateExternalUser({
          user_id: this.data.id,
          name: this.name.trim(),
          email: this.email,
          role_id: this.roleIds.TR,
          categories: this.selectedSubject,
          class: this.selectedClass.title,
          batches: batches,
          is_approved: true,
        })
          .then((response) => {
            this.loading = false;
            this.email = "";
            this.name = "";
            this.$toasted.success(`Teacher Updated Successfully`, {
              icon: "check_circle",
            });
            this.saveLoading = false;

            this.loading = false;

            this.onClose({ status: false, reload: true });
          })
          .catch((err) => {
            this.loading = false;
            this.saveLoading = false;
          });
      } else {
        this.loading = false;
      }
    },
    requestGetBatch(centerId) {
      let reqData = {
        center_id: [centerId],
      };

      this.getBatches(reqData)
        .then((response) => {
          this.loading = false;
          let tmpCenter = this.centers.filter((x) => x.value === centerId);
          if (response && response.list && response.list.length) {
            let tmpBatch = response.list.map((x) => {
              let c = {};
              c.text = x.name;
              c.value = x.id;
              c.center_id = x.center_id;
              c.checked = false;
              c.subject_id = x.subject_ids.split(',').map(s=>parseInt(s));
              return c;
            });
            let maxIdx = this.selectedCenterList.length;
            this.selectedCenterList.push({
              ...tmpCenter[0],
              batches: tmpBatch,
              class: maxIdx + 'center',
            });
            this.selectedCenterList.sort(function(a, b){
                var nameA=a.text.toLowerCase(), nameB=b.text.toLowerCase();
                if (nameA < nameB) 
                  return -1;
                if (nameA > nameB)
                  return 1;
                return 0; 
                });

            this.centers = this.centers.filter((x) => x.value !== centerId);
            this.disableBatches()

          } else {
            this.$toasted.error(
              `Batches not available for center ${tmpCenter[0].text}`,
              { icon: "info" }
            );
            this.centers = this.centers.filter((x) => x.value !== centerId);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getAlreadySelectedBatches() {
      const reqData = {
        teacher_id: this.data.id,
      };
      let tempcenter = [];
      let tempBatches = [];
      this.getTeacherDetails(reqData)
        .then((response) => {
          let selectedCenter = [];
          response.centerBatches.map((res,idx) => {
            let center = {
              text: res.name,
              value: res.id,
              batches: [],
              class: idx + 'center',
            };
            tempcenter.push(res.id);
            res.batches.map((b) => {
              let batch = {
                text: b.name,
                value: b.id,
                center_id: b.center_id,
                checked: b.is_selected === 1,
              	subject_id : b.subject_ids.map(s=>parseInt(s.id)),

				disabled:false
              };
              tempBatches.push(b.id);
              center.batches.push(batch);
            });
            selectedCenter.push(center);
          });
          this.selectedCenterList = selectedCenter;
		  
          this.selectedCenterList.sort(function(a, b){
                var nameA=a.text.toLowerCase(), nameB=b.text.toLowerCase();
                if (nameA < nameB) 
                  return -1;
                if (nameA > nameB)
                  return 1;
                return 0; 
                });
				this.disableBatches();
          this.requestGetCenters(tempcenter);
        })
        .catch((err) => {
          console.log(err);
        });
      return tempcenter;
    },
    onSubjectSelect(selectedSubject) {
      this.selectedSubject = selectedSubject;
	  this.disableBatches()	
    },
    testLogicForScroll() {
      var elem = document.getElementById(this.selectedCenterList.length - 1 + 'center');
      if (elem) {
        
        elem.scrollIntoView();
      }
    },
	disableBatches(){
			this.selectedCenterList.map(center => {
				center.batches.map(b => {
					if(this.selectedSubject && this.selectedSubject.length){
					
						b.disabled = !(this.selectedSubject.findIndex(s=>b.subject_id && b.subject_id.length && b.subject_id.includes(s)) >=0)
					}else{
						b.disabled = true
					}
				})
			})
}
  },
  mounted() {
    this.requestGetClasses();
    this.getAlreadySelectedBatches();
  },
  watch: {
    status(val) {
      this.name = this.data ? this.data.name : null;
      this.email = this.data ? this.data.email : null;
      this.selectedSubject = this.data.subjects ? this.data.subjects : [];
      this.selectedCenterList = [];
      this.showAddcenterButton = true;
      this.selectedCenterId = null;
      this.getAlreadySelectedBatches(); 

      this.requestGetClasses();
    },
    selectedSubject(val) {
      this.error.subjects.type = null;
    },
    name() {
      this.error.name.type = null;
    },
    email() {
      this.error.email.type = null;
    },
    selectedClass(val) {
      this.error.dataType.type = null;
    },
    selectedCenterId(val) {
      if (this.selectedCenterId) {
        this.showAddcenterButton = true;
        this.requestGetBatch(val);
      }
    },
    selectedCenterList(val)
    {
      let me = this;
       setTimeout(()=> {
            me.testLogicForScroll();
        }, 100);
      
    },
  },
};
</script>
